export default "__VITE_ASSET__Dwu9zps2__"